import { inject } from '@angular/core';
import { CanMatchFn, RedirectFunction, Routes } from '@angular/router';
import { APP_ROOT } from './injectionTokens/app-root';
import { PlatformService } from '@doka/angular-core';
import { authGuard, LogoutComponent } from '@doka/identity-login';

export const rootRedirect: RedirectFunction = () => {
  const root = inject(APP_ROOT);
  console.log(root);

  return root;
};

//Logic for different Root Page depending on Platform

export const isMobileMatch: CanMatchFn = () => {
  const platform = inject(PlatformService);
  return platform.platform$() === 'mobile';
};

export const isWebMatch: CanMatchFn = () => {
  const platform = inject(PlatformService);
  return platform.platform$() === 'web';
};

// The whole rootRedirect logic is only needed if a different page should serve as root page depending on the platform

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: rootRedirect,
  },
  {
    path: 'return',
    loadChildren: () => import('./return-home/return.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'settings',
    loadComponent: () => import('./settings/settings').then((m) => m.Settings),
    canActivate: [authGuard],
  },
  /* {
    path: 'unauthorized',
    component: UnauthorizedComponent,
  }, */
];
